var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTravel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "travel",
    d: "M13,6H6A3,3,0,0,0,3,9v8a3,3,0,0,0,3,3L5,21v1H6l2-2.03L10,20V15H5V8h9v2h2V9a3,3,0,0,0-3-3M6,16a1,1,0,1,1-1,1,1,1,0,0,1,1-1m15.57-4.34A1,1,0,0,0,20.6,11H13.41a1.016,1.016,0,0,0-.98.66L11,15.77v5.51a.726.726,0,0,0,.7.72h.62a.746.746,0,0,0,.68-.76V20h8v1.24a.755.755,0,0,0,.69.76h.61a.726.726,0,0,0,.7-.72V15.77l-1.43-4.11M13.41,12H20.6l1.03,3H12.38l1.03-3M13,18a1,1,0,1,1,1-1,1,1,0,0,1-1,1m8,0a1,1,0,1,1,1-1A1,1,0,0,1,21,18Z",
    transform: "translate(-3 -6)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTravel);
export default __webpack_public_path__ + "static/media/icon_travel.ef89ad6a7688a61c630a6ad44b643fba.svg";
export { ForwardRef as ReactComponent };